import * as React from "react";
import {FieldWrapper} from "./FieldWrapper";
import {toArray} from "../../../../../../../utils/array";
import { ChipField } from "../../../../../../Components/Form/ChipField";

export const TagsField = ({value, onChange, onDelete}: any) => (
    <FieldWrapper onDelete={onDelete}>
        <ChipField
            value={toArray(value)}
            onChange={onChange}
            label="Tags"
        />
    </FieldWrapper>
);
